import { useState } from "react";
import { Button } from "@/core/components/ui/button";
import { Stack } from "@/core/components/ui/stack/stack";
import { Typography } from "@/core/components/ui/typography";
import { useAuth } from "@/core/auth";
import { formatCountdown, useCountdown } from "@/core/hooks";

interface ResendCodeButtonProps {
  onResend: () => Promise<void>;
}

export const ResendCodeButton = ({ onResend }: ResendCodeButtonProps) => {
  const { forgotPasswordEmail, getResetCodeResendAvailableAt } = useAuth();
  const secondsLeft = useCountdown(
    getResetCodeResendAvailableAt(forgotPasswordEmail),
  );
  const [isResending, setIsResending] = useState(false);

  const handleClick = async () => {
    setIsResending(true);
    try {
      await onResend();
    } finally {
      setIsResending(false);
    }
  };

  return (
    <Stack
      direction="row"
      align="center"
      justify="center"
      gap="none"
      className="flex-wrap"
    >
      <Typography variant="bodyW1" textColor="secondary">
        Didn&apos;t get a code?
      </Typography>
      <Button
        type="button"
        variant="text"
        size="sm"
        className="px-2 tabular-nums"
        disabled={secondsLeft > 0}
        loading={isResending}
        onClick={handleClick}
      >
        {secondsLeft > 0
          ? `Resend code in ${formatCountdown(secondsLeft)}`
          : "Resend code"}
      </Button>
    </Stack>
  );
};
